import { styled } from '@mui/material';

export const ThumbsList = styled('div')`
  height: 8rem;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 0.75rem;
  white-space: nowrap;

  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const ThumbsListItem = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'active',
})<{ active?: boolean }>(({ active, theme }) => ({
  width: '7.5rem',
  height: '7.5rem',
  opacity: active ? 1 : 0.5,
  border: `2px solid ${active ? theme.palette.accent.main : 'rgb(245, 245, 247)'}`,
  borderRadius: '1rem',
  overflow: 'hidden',
}));

export const Thumb = styled(`img`)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
